module.exports = {"371703001":"天中街道","371703002":"滨河街道","371703101":"陈集镇","371703102":"冉固镇","371703103":"张湾镇","371703104":"黄店镇","371703105":"孟海镇","371703106":"马集镇","371703107":"仿山镇","371703108":"半堤镇","371703109":"杜堂镇","371703110":"南王店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371703.json
// module id = 1380
// module chunks = 0